import { ALLI_AI_BRAND_NAME } from "~/helpers/consts";

import DefaultLogoUrl from "./DefaultLogo.svg?url";
import { WhiteLabelConfig, isAlliAiAppHost } from "./types";

export const DefaultWhiteLabelConfig: WhiteLabelConfig = {
  company_name: ALLI_AI_BRAND_NAME,
  logo_url: DefaultLogoUrl,
  host: window.location.host,
  alliaiapp: isAlliAiAppHost(window.location.host),
};
